import { TIER } from 'utilsTS/dom';

const DEFAULT_TIER = TIER.LG;

export { TIER, DEFAULT_TIER };
